import { API_URL } from "@/global";

export const OTHER_APIS = `${API_URL}/others`;
export const REPORT_APIS = `${OTHER_APIS}/reports`;
export const QUARTERLY_REPORT_API = `${REPORT_APIS}/quarterly`;
export const ANNUAL_REPORT_API = `${REPORT_APIS}/annual`;
export const SENSITIVE_REPORT_API = `${REPORT_APIS}/sensitive`;
export const OTHER_REPORT_API = `${REPORT_APIS}/other`;
